import React from 'react';
import { Footer } from '../../../common/footer/footer';
import 'aos/dist/aos.css';
import Sidebar from "../sidebar/sidebar.js";

export const CustomerAskTheExpertJsx = (props) => {
  const {
    categoryData,
    handleChange,
    getCheckedIds
  } = props;

  return (
    <>
      <section className="entiredashboard admindashboard py-5 bg-light">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-lg-3 col-sm-12 mb-4">
              <div className="dashboardleftpanel p-3 bg-white shadow rounded">
                <Sidebar />
              </div>
            </div>

            {/* Main Content */}
            <div className="col-lg-9 col-sm-12">
              <div className="dashboardrightpanel p-4 bg-white shadow rounded">
                <h2 className="mb-4 text-primary">Role Management</h2>

                <div className="expertsection">
                  {categoryData?.length > 0 ? (
                    <>
                      <div className="searchdetails">
                        {categoryData.map((data, moduleIndex) => (
                          <div 
                            key={`module-${data.moduleId}`} 
                            className="mb-4 p-4 border rounded bg-light"
                          >
                            <h4 className="text-dark mb-3">{data?.moduleName}</h4>

                            <div className="row">
                              {data?.modulePermissions?.map((role, roleIndex) => (
                                <div 
                                  key={`permission-${role.modulePermissionId}`} 
                                  className="col-md-6 mb-2"
                                >
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`${role.name}-${role.modulePermissionId}`}
                                      name={role.name}
                                      value={role.modulePermissionId}
                                      checked={role.hasPermission}
                                      onChange={(e) =>
                                        handleChange({
                                          modulePermissionId: role.modulePermissionId,
                                          moduleId: data.moduleId,
                                          checked: e.target.checked,
                                        })
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`${role.name}-${role.modulePermissionId}`}
                                    >
                                      {role.name}
                                    </label>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="text-end">
                        <button 
                          onClick={getCheckedIds} 
                          className="btn btn-primary px-4 py-2"
                        >
                          Submit
                        </button>
                      </div>
                    </>
                  ) : (
                    <p className="text-muted">No role data available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default CustomerAskTheExpertJsx;
